module.exports = __webpack_public_path__ + "static/media/greenhouse2Step6-3.20509a96.jpg";